import { createSlice } from "@reduxjs/toolkit";
import { getQuestionnaireById, submitAnswers } from "../../api/APIServices";
import { API_STATUS } from "../../constants";

const initialState = {status:API_STATUS.IDEL, isSubmitAnswers:false, answers:[], questionnaire:[]};
const questionnaireSlice = createSlice({
    name:'questionnaire',
    initialState,
    reducers:{
        setAnswers(state, action) {
            state.answers = action.payload;
        },
     },
    extraReducers:(builder)=>{
        builder.addCase(getQuestionnaireById.fulfilled, (state, action)=> {
            state.questionnaire = action.payload.questionnaire;
            state.answers = action.payload.answers;
            state.status = API_STATUS.SUCCESS;
        }),
        builder.addCase(getQuestionnaireById.pending, (state)=> {
            state.status = API_STATUS.PENDING;
        }),
        builder.addCase(getQuestionnaireById.rejected, (state)=> { 
            state.status = API_STATUS.ERROR;
        })

        builder.addCase(submitAnswers.fulfilled, (state, action)=> {
            state.status = API_STATUS.SUCCESS;
            state.isSubmitAnswers = true
        }),
        builder.addCase(submitAnswers.pending, (state)=>{
            state.status = API_STATUS.PENDING;
        }),
        builder.addCase(submitAnswers.rejected, (state)=>{
            state.status = API_STATUS.ERROR;
        })
    }
});

export const {setAnswers} = questionnaireSlice.actions;
export default questionnaireSlice.reducer;